/**
 * @file        src/layout/MobileNavButton.jsx
 * @description Mobile-only hamburger button (top-left) — toggles the sidebar
 *              drawer. Fixed in place while scrolling; hidden only while the
 *              drawer is open (the sidebar's own close button shows instead).
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 *   - 2026-06-22 Claude — Moved to top-left to follow the sidebar move.
 *   - 2026-06-23 Claude — Hide while the drawer is open (the sidebar's own
 *                          close button is shown instead).
 *   - 2026-06-23 Claude — Auto-hide on scroll-down, reveal on scroll-up / near
 *                          top, so it stops overlapping page content.
 *   - 2026-07-24 Claude — Removed the scroll auto-hide: the button now stays
 *                          fixed in place (pages that stick content at the top,
 *                          like flight results, indent past it instead).
 *   - 2026-07-26 Claude — Nudged to top-5 left-5 so it sits centred on the first
 *                          field row of the sticky search summaries (hotel/flight
 *                          results) instead of 4px above it.
 */
import React from 'react';
import { useBooking } from '../store/booking.store.js';

export default function MobileNavButton() {
  const openNav = useBooking((s) => s.openNav);
  const navOpen = useBooking((s) => s.navOpen);

  if (navOpen) return null;

  return (
    <button
      onClick={openNav}
      className="lg:hidden fixed top-5 left-5 z-[60] w-11 h-11 rounded-xl bg-panel border border-line flex items-center justify-center cursor-pointer shadow-lg"
      aria-label="Open menu"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 text-neon">
        <path fill="currentColor" d="M3 6h18v2H3zm0 5h18v2H3zm0 5h18v2H3z" />
      </svg>
    </button>
  );
}
